import React, { useEffect, useState } from 'react';
import axios from 'axios';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import { Upload, message, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { API_DOWNLOAD, IPAddress, MAXIMO } from '../../../../commons/api';
import { StyledHomepage } from '../../../../commons/styles/layout';

const FileUploadAndDownload = () => {
  const [fileName, setFileName] = useState('');
  const [maximoDataSource, setMaximoDataSource] = useState([]);
  const configType = 'deviceConfig';

  useEffect(() => {
    getFile('deviceConfig');
    getMaximoList('deviceConfig');
  }, []);

  const getFile = (value) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMO.Download}?configtype=${value}&SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setFileName(response.data.file);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getMaximoList = (value) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const headers = {
      method: 'GET',
      url: `${MAXIMO.List}?configtype=${value}&SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    axios(headers)
      .then((response) => {
        setMaximoDataSource(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const beforeUpload = (file) => {
    const isLt2M = file.size / 1024 / 1024 < 10;
    const isCSV =
      file.type === 'text/csv' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.ms-excel';

    if (!isCSV) {
      message.error('You can only upload CSV file!');
    }
    if (!isLt2M) {
      message.error('CSV file must be smaller than 10MB!');
    }

    return isLt2M && isCSV;
  };

  const handleChange = (info) => {
    const { status } = info.file;
    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const maximoCol = [
    { title: 'Device', dataIndex: 'Device', key: 'Device' },
    { title: 'Parameter Code', dataIndex: 'ParameterCode', key: 'ParameterCode' },
    { title: 'Site', dataIndex: 'Site', key: 'Site' },
    { title: 'Location', dataIndex: 'Location', key: 'Location' },
    { title: 'Asset', dataIndex: 'Asset', key: 'Asset' },
    { title: 'Meter', dataIndex: 'Meter', key: 'Meter' },
    { title: 'Meter Type', dataIndex: 'MeterType', key: 'MeterType' },
    { title: 'Lower Action', dataIndex: 'LowerAction', key: 'LowerAction' },
    { title: 'Lower Warning', dataIndex: 'LowerWarning', key: 'LowerWarning' },
    { title: 'Upper Warning', dataIndex: 'UpperWarning', key: 'UpperWarning' },
    { title: 'Upper Action', dataIndex: 'UpperAction', key: 'UpperAction' },
    { title: 'Status', dataIndex: 'Status', key: 'Status' }
  ];

  const token = localStorage.get('accessToken');
  const Authorization = `Bearer ${token}`;
  const siteId = localStorage.get('currentSite');

  return (
    <StyledHomepage>
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "10px" }}>
          {fileName ? (
            <a href={`${IPAddress.LOCAL}${API_DOWNLOAD.DownLoads}/${fileName}?configtype=${configType}`}>
              <Button type='primary'>
                <DownOutlined /> {fileName}
              </Button>
            </a>
          ) : (
            <Button type='primary'>No file to download</Button>
          )}
        </div>
        <Upload
          name="file"
          accept=".csv"
          action={`${MAXIMO.UPLOAD}?configtype=${configType}&SiteId=${siteId}`}
          headers={{ Authorization }}
          multiple={false}
          beforeUpload={beforeUpload}
          onChange={handleChange}
        >
          <Button type="primary">Upload CSV File</Button>
        </Upload>
      </div>
      <div style={{ marginTop: '20px' }}>
        <StyledTable
          size="small"
          columns={maximoCol}
          pagination={
            maximoDataSource.length > 10
              ? { pageSize: 10 }
              : false
          }
          dataSource={maximoDataSource.map((data, index) => ({ ...data, key: index }))}
        />
      </div>
    </StyledHomepage>
  );
};

export default FileUploadAndDownload;
